var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entreprise-linkbar"},_vm._l((_vm.linkList),function(link){return _c('router-link',{key:link.url,attrs:{"to":`/admin/entreprise/${_vm.entrepriseId}/${link.url}`}},[_vm._v(" "+_vm._s(link.displayText)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }